import type { TypedSocket } from '@context/socket.context';

export function deleteMessage(socket: TypedSocket, messageId: number): void {
  socket.emit('delete-message', {
    id: messageId,
  });
}
